import React, { useEffect, useState } from 'react'
import { nativeCheckoutReturnPath } from '../lib/hostedCheckout'
import { useSearchParams } from 'react-router-dom'
import { usePaymentPresentationLocale } from '../lib/usePaymentPresentationLocale'

// Public handoff only. The installed app still verifies payment with its own
// authenticated session; no identity or payment outcome is accepted from this URL.
export default function MemberNativeCheckoutReturnPage() {
  const [params] = useSearchParams()
  const { t } = usePaymentPresentationLocale(false)
  const path = params.get('path') || ''
  const deepLink=`com.privana.members://checkout?path=${encodeURIComponent(path)}`
  const clubCode=path.match(/^\/(\d{6})\//)?.[1]
  const webPath=nativeCheckoutReturnPath(deepLink,clubCode)
  const [failed, setFailed] = useState(false)
  useEffect(() => {
    setFailed(false)
    if (!webPath) return
    let timer = null
    const suspendRecovery = () => {
      window.clearTimeout(timer)
      timer = null
      setFailed(false)
    }
    const scheduleRecovery = () => {
      if (document.visibilityState !== 'visible' || timer !== null) return
      timer = window.setTimeout(() => {
        timer = null
        if (document.visibilityState === 'visible') setFailed(true)
      }, 2000)
    }
    const visibilityChanged = () => {
      if (document.visibilityState === 'hidden') suspendRecovery()
      else scheduleRecovery()
    }
    document.addEventListener('visibilitychange', visibilityChanged)
    window.addEventListener('pagehide', suspendRecovery)
    window.addEventListener('pageshow', scheduleRecovery)
    // The native checkout URL is generated only for a native checkout. Ordinary
    // web success/cancel URLs go straight to their module confirmation route.
    try { window.location.assign(deepLink) } catch { setFailed(document.visibilityState === 'visible') }
    // Leaving the page is not acknowledgement from the app. If this document
    // returns (including from the back/forward cache), offer recovery after a
    // fresh bounded delay, without automatically launching the deep link again.
    scheduleRecovery()
    return () => {
      window.clearTimeout(timer)
      document.removeEventListener('visibilitychange', visibilityChanged)
      window.removeEventListener('pagehide', suspendRecovery)
      window.removeEventListener('pageshow', scheduleRecovery)
    }
  }, [deepLink, webPath])
  if (!failed || !webPath) return null
  return <div className="mp-payment-result"><div className="mp-payment-result__card">
    <a className="mp-primary" href={deepLink}>{t('memberAccount.returnToApp')}</a>
    {webPath ? <a className="mp-btn mp-btn--outline" href={webPath}>{t('portalPresentation.member_continue')}</a> : null}
  </div></div>
}
